import { render, staticRenderFns } from "./passenger-list.vue?vue&type=template&id=300b1c7d"
import script from "./passenger-list.vue?vue&type=script&lang=js"
export * from "./passenger-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports